// extracted by mini-css-extract-plugin
export default {"ExerciseTab":"ExerciseTab_ExerciseTab__DHKzD","tip":"ExerciseTab_tip__qVNbZ","actions":"ExerciseTab_actions__alpwW","elementSelect":"ExerciseTab_elementSelect__poipG"};